import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import StatusBadge from 'common/StatusBadge';
import TableStructure from 'common/TableStructure';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import React from 'react';

export const GridContainer = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    overflow-x: auto;
    
    @media (min-width: 768px) {
        overflow-x: visible;
    }
`;
export default function ProviderTable({ rows, handleRowClick, setProviderList, getProviderList }) {

    const columns = [
        {
            field: 'id',
            headerName: <FormattedMessage id="be.seen.invoice.table.date" defaultMessage="ID" />,
            flex: 0.5,
            minWidth: 80,
        },
        {
            field: 'status',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="STATUS" />,
            flex: 0.8,
            minWidth: 120,
            renderCell: (params) => {
                return <StatusBadge status={params?.row?.status}></StatusBadge>;
            },
        },
        {
            field: 'name',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="NAME" />,
            flex: 1,
            minWidth: 150,
        },
        {
            field: 'handle',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="HANDLE" />,
            flex: 1,
            minWidth: 150,
        },
        {
            field: 'email',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="EMAIL" />,
            flex: 1.2,
            minWidth: 180,
        },

        {
            field: 'actions',
            headerName: '',
            sortable: false,
            flex: 0.5,
            minWidth: 70,
            renderCell: (params) => {
                return (
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                            cursor: 'pointer',
                            marginLeft: 'auto',
                            marginRight: '12px',
                        }}
                    >
                        <path
                            d="M9 18L15 12L9 6"
                            stroke="#666666"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                );
            },
        },
    ];
    return (
        <GridContainer>
            <TableStructure rows={rows} columns={columns} handleRowClick={handleRowClick}></TableStructure>
        </GridContainer>
    );
}
